<template>
  <div class="flex h-screen bg-md-surface overflow-hidden">
    <SideBar :open="sidebarOpen" @toggle="sidebarOpen = !sidebarOpen" />

    <!-- Backdrop on tablet/mobile -->
    <div
      v-if="sidebarOpen"
      class="fixed inset-0 bg-black/50 z-40 lg:hidden"
      @click="sidebarOpen = false"
    />

    <main class="flex-1 overflow-hidden">
      <div class="p-4 md:p-6 max-w-[1440px] mx-auto h-full flex flex-col">
        <div v-if="!sidebarOpen" class="mb-4 shrink-0 flex items-center gap-3">
          <button
            type="button"
            class="rounded-md bg-md-surface p-2 border border-md-outline-variant text-md-on-surface hover:bg-md-surface-hover"
            aria-label="Открыть меню"
            @click="sidebarOpen = true"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="20"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            >
              <line x1="3" y1="12" x2="21" y2="12" />
              <line x1="3" y1="6" x2="21" y2="6" />
              <line x1="3" y1="18" x2="21" y2="18" />
            </svg>
          </button>
          <h1 class="text-xl font-medium text-md-on-surface">{{ pageTitle }}</h1>
        </div>
        <router-view />
      </div>
    </main>
  </div>
</template>

<script setup lang="ts">
import { computed, onMounted, onUnmounted, ref } from 'vue';
import { useRoute } from 'vue-router';
import SideBar from './SideBar.vue';

const sidebarOpen = ref(true);
const $route = useRoute();
const pageTitle = computed(() => ($route.meta.title as string) ?? '');

const checkWidth = () => {
  sidebarOpen.value = window.innerWidth >= 1024;
};

onMounted(() => {
  checkWidth();
  window.addEventListener('resize', checkWidth);
});
onUnmounted(() => {
  window.removeEventListener('resize', checkWidth);
});
</script>
